export function formatAsBRL(number) {
  return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}
